// Formatação Regra 6: nada é arredondado nem abreviado ("5M" não existe)
export const fmtInt = (v) =>
  v === null || v === undefined ? 'sem dado' : Number(v).toLocaleString('pt-BR');

export const fmtDecimal = (v, digits = 2) =>
  v === null || v === undefined ? 'sem dado'
    : Number(v).toLocaleString('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits });

export const fmtUSD = (v) =>
  v === null || v === undefined ? 'sem dado' : `US$ ${fmtDecimal(v)}`;

// Quantidade de presentes: inteiro aparece limpo, fracionado com duas casas
export const fmtGifts = (v) =>
  v === null || v === undefined ? 'sem dado'
    : Number.isInteger(Number(v)) ? fmtInt(v) : fmtDecimal(v);

export const fmtMinutes = (mins) => {
  if (mins === null || mins === undefined) return 'sem dado';
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  return h > 0 ? `${h}h ${m}min` : `${m}min`;
};

export const fmtHours = (mins) =>
  mins === null || mins === undefined ? 'sem dado' : `${mins / 60}h`;
